/* Loaded Concept, 2026-10-10. Search, account and cart in the announcement bar
   (sections/announcement-bar.liquid, setting "kgs_tools"; styles in kgs-topbar.css).
   Search and cart hand their click to the header's own (hidden) links, so the theme's search panel
   and cart drawer open exactly as before. The cart count is copied from the header after the theme
   refreshes it. Without the header link, the bar link works as a plain link. */
(() => {
  if (customElements.get('kgs-topbar-tools')) return;

  const headerCount = () => {
    const count = document.querySelector('#pageheader .logo-area__right .cart-link__count');
    return count ? count.textContent.trim() : '0';
  };

  class KgsTopbarTools extends HTMLElement {
    connectedCallback() {
      if (!this.wired) {
        this.wired = true;
        this.addEventListener('click', (evt) => {
          const link = evt.target.closest('[data-kgs-proxy]');
          if (!link || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
          const target = document.querySelector(link.dataset.kgsProxy);
          if (!target) return;
          evt.preventDefault();
          target.click();
        });
      }

      const count = this.querySelector('[data-kgs-cart-count]');
      const header = document.querySelector('#pageheader .logo-area__right');
      if (!count || !header || this.observer) return;
      const sync = () => {
        const value = headerCount();
        if (count.textContent !== value) count.textContent = value;
        count.hidden = value === '0' || value === '';
      };
      // The theme replaces the header's cart link after every cart change (PageHeader.refreshHeader).
      // In the theme editor the header can be re-rendered as a new node: pick that one up instead.
      this.observer = new MutationObserver(sync);
      this.observer.observe(header, { childList: true, subtree: true });
      this.headerObserver = new MutationObserver(() => {
        const current = document.querySelector('#pageheader .logo-area__right');
        if (current && current !== this.watched) {
          this.watched = current;
          this.observer.disconnect();
          this.observer.observe(current, { childList: true, subtree: true });
          sync();
        }
      });
      this.watched = header;
      if (window.Shopify && window.Shopify.designMode) {
        this.headerObserver.observe(document.body, { childList: true, subtree: true });
      }
      sync();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.headerObserver) this.headerObserver.disconnect();
      this.observer = null;
      this.headerObserver = null;
    }
  }

  customElements.define('kgs-topbar-tools', KgsTopbarTools);
})();
